"use strict";
exports.__esModule = true;
exports.SETTINGS_PROPERTY_MOVING_SECTION = void 0;
exports.SETTINGS_PROPERTY_MOVING_SECTION = {
    TEXT: 'Need to update your address? ',
    LINK: 'Link new property'
};
